import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, } from '@angular/forms';
import { TranslateModule } from 'ng2-translate';
import { TooltipModule } from 'ng2-tooltip';
import { TinymceModule } from 'angular2-tinymce';

import { ConfirmationModule } from '../../../../shared/modules/confirmation/confirmation.module';
import { TaskComponent } from './task.component';
import { TaskViewComponent } from './task-view.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TooltipModule,
    ConfirmationModule,
    TinymceModule.withConfig({ menubar: false })
  ],
  declarations: [TaskComponent, TaskViewComponent],
  exports: [TaskComponent, TaskViewComponent]
})
export class ModalTaskModule { }


// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-task/modal-task.module.ts